export default __webpack_public_path__ + "static/testimonial photo@3x-df22776938df389c38e86283364c3c96.png";